import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UserDataModel } from '../../header/userData.model';
import { ActivityModel } from '../../../modules/user/activity/activity.model';
import { NotificationService } from '../../../modules/notification/notification.service';
import { NotificationModel } from '../../../modules/notification/notification.model';
import { interval, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ActualSelected, GeneralText } from '../../../shared/utils';
import { DummyComponent } from '../../../shared/dummy.component';
import { GeneralTextService } from '../../../shared/general-text.service';
import { CoreComponent } from '../../header/core.component';
import { UserCompanyModule } from '../../../modules/user/usercompany/userCompanyModule.model';
import { UserCompanyService } from '../../../modules/user/usercompany/usercompany.service';
import { ResizeService } from '../../size-detector/resize.service';
import { delay } from 'rxjs/operators';
import { SCREEN_SIZE } from '../../size-detector/screen-size.enum';
import { FirstStepsDialogService } from '../../../shared/components/first-steps-dialog/first-steps-dialog.service';
import { ConsultantService } from '../../../modules/consultant/consultant.service';
import { AuthService } from '../../guards/auth/auth.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Output() public sidebarToggle = new EventEmitter<void>();

  holaString: string;
  notificationList: NotificationModel[] = [];
  notificationObservable: Subscription | null = null;

  @Input() user: UserDataModel;

  @Input() activitySelected: string;
  @Input() activity: ActivityModel[] = [];
  @Input() changeActivity: Function;

  @Input() yearSelected: number;
  @Input() years: number[] = [];
  @Input() changeYear: Function;

  static notificationsCount: number;

  modules: UserCompanyModule[] = [];
  showHelp = false;
  canOCR: boolean = this.core.canOCR;
  ready = false;
  companyName: string;

  private companyNameSubscriber: Subscription | null = null;
  private resizeSubscription: Subscription | null = null;
  private firstStepsSubscriber: Subscription | null = null;

  isEnableFirstSteps = false;

  size: SCREEN_SIZE;

  showAsesoria = false;

  public consultantBusinessGroupInfo: { isBusinessGroup: boolean; isConsultant: boolean; status: boolean } = {
    isBusinessGroup: false,
    isConsultant: false,
    status: false,
  };

  constructor(
    protected notificationService: NotificationService,
    public dummy: DummyComponent,
    private core: CoreComponent,
    private GeneralTextService: GeneralTextService,
    private router: Router,
    private userCompanyService: UserCompanyService,
    private resizeSvc: ResizeService,
    private firstStepsDialogService: FirstStepsDialogService,
    private consultantService: ConsultantService,
    private authService: AuthService,
  ) { }

  alertFunc() {
  }

  ngOnInit(): void {
    this.resizeSubscription = this.resizeSvc.onResize$
      .pipe(delay(0))
      .subscribe(x => {
        this.size = x;
      });

    this.userCompanyService.loadData().then(response => {
      this.companyName = response.companyName;

      ActualSelected.numDecimals = response.numDecimals;

      // Remove Suscripcion from main menú
      this.modules = response.modules.filter(element => element.onClick !== '/subscription');

      // TEMPORAL - QUITAREMOS DEL MENÚ OCR Y AÑADIREMOS FICHEROS
      this.modules = this.modules.filter(element => element.onClick !== '/ocrHistory');

      this.modules.push({
        uid: '00000000-0000-0000-0000-000000000000',
        modelName: 'Ficheros',
        modelIncluded: true,
        icon: 'folder',
        onClick: '/files',
        mainModuleId: null,
        showModule: true,
        showNavbar: true,
        path: ''
      });

      this.modules.push({
        uid: '00000000-0000-0000-0000-000000000000',
        modelName: 'Personal',
        modelIncluded: true,
        icon: '',
        onClick: '/employees',
        mainModuleId: null,
        showModule: true,
        showNavbar: true,
        path: ''
      });

      // TODO - TEMPORAL
      this.modules.push({
        uid: '00000000-0000-0000-0000-000000000000',
        modelName: 'Finanzas',
        modelIncluded: true,
        icon: '',
        onClick: '/finance',
        mainModuleId: null,
        showModule: true,
        showNavbar: true,
        path: ''
      });

      const totalLengthModules = this.modules.length - 1;
      const filesModule = this.modules[totalLengthModules];
      const suscriptionModule = this.modules[totalLengthModules - 1];
      this.modules[totalLengthModules - 1] = filesModule;
      this.modules[totalLengthModules] = suscriptionModule;

      this.showHelp = ActualSelected.showHelp;

      if (this.user && this.user.username) {
        this.holaString = this.user.username.substring(0, this.user.username.indexOf('@'));
      }

      NavbarComponent.notificationsCount = 0;

      const url = this.router.url;

      if (!url.includes('/subscription?session_id') && this.canOCR) {
        this.checkNotifications();
        this.notificationObservable = interval(1000000).subscribe(() => {
          this.checkNotifications();
        });
      }

      this.modules = this.orderMenuModules(this.modules);

      this.ready = true;
    });

    this.companyNameSubscriber = this.userCompanyService.companyName$.subscribe(data => {
      this.companyName = data;
    });

    this.firstStepsSubscriber = this.firstStepsDialogService.isEnabledDisableFirstSteps.subscribe(data => {
      this.isEnableFirstSteps = data;
    });

    this.consultantService.statusClientConsultant()
      .then(response => {
        this.consultantBusinessGroupInfo = response;
      })
      .catch(_err => {
        this.consultantBusinessGroupInfo.status = false;
      });
  }

  public backToConsulting() {
    this.consultantService.viewAsesor()
      .then(responseConsultant => {
        if (responseConsultant) {
          this.authService.logout();

          this.authService.loginAsor('abc', 'abc', responseConsultant, 'cliente').then(
            result => {
              if (result) {
                this.authService.saveToLocalStorageStatusBackFromUser(true);
                window.location.href = '/consultant';
              } else {
                this.authService.saveToLocalStorageStatusBackFromUser(false);
              }
            }
          ).catch(_err => {
            this.authService.saveToLocalStorageStatusBackFromUser(false);
          });
        }
      })
      .catch(_err => {
        this.authService.saveToLocalStorageStatusBackFromUser(false);
      });
  }

  private orderMenuModules(modules: UserCompanyModule[]) {
    const ordered: UserCompanyModule[] = [];

    ordered.push(modules.find(x => x.onClick === '/resume'));
    ordered.push(modules.find(x => x.onClick === '/account'));
    ordered.push(modules.find(x => x.onClick === '/concept'));
    ordered.push(modules.find(x => x.onClick === '/invoice'));
    ordered.push(modules.find(x => x.onClick === '/expense'));
    ordered.push(modules.find(x => x.onClick === '/investment'));
    ordered.push(modules.find(x => x.onClick === '/finance'));
    ordered.push(modules.find(x => x.onClick === '/employees'));
    ordered.push(modules.find(x => x.onClick === '/accounting'));
    ordered.push(modules.find(x => x.onClick === '/taxes'));
    ordered.push(modules.find(x => x.onClick === '/files'));

    return ordered.filter(Boolean);
  }

  disableEnableFirstSteps() {
    this.isEnableFirstSteps = !this.isEnableFirstSteps;
    this.firstStepsDialogService.editEnableDisableFirstSteps(this.isEnableFirstSteps)
      .catch(_err => {
        // console.log(err)
      });
  }

  public onToggleSidebar = () => {
    this.sidebarToggle.emit();
  }

  checkNotifications(): void {
    this.notificationService.getUnreadList().then(r => {
      this.notificationList = r;
      NavbarComponent.notificationsCount = this.notificationList.length;
    });
  }

  sendNotification(notification: NotificationModel) {
    this.notificationService.sendNotification(notification);
  }

  get getNotificationCount() {
    return NavbarComponent.notificationsCount;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    if (this.companyNameSubscriber) {
      this.companyNameSubscriber.unsubscribe();
      this.companyNameSubscriber = null;
    }

    if (this.firstStepsSubscriber) {
      this.firstStepsSubscriber.unsubscribe();
      this.firstStepsSubscriber = null;
    }

    if (this.notificationObservable) {
      this.notificationObservable.unsubscribe();
      this.notificationObservable = null;
    }

    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
      this.resizeSubscription = null;
    }
  }

  public static updateNotifications(total: number): void {
    NavbarComponent.notificationsCount = total;
  }

  public toggleHelp() {
    this.showHelp = !this.showHelp;
    ActualSelected.showHelp = !ActualSelected.showHelp;

    if (this.showHelp && (GeneralText.help == null || GeneralText.help.length == 0)) {
      this.GeneralTextService.GetHelpList().then(result => {
        GeneralText.help = result;
        this.dummy.redirectTo(this.router.url);
      }, _error => {
      });
    } else {
      this.dummy.redirectTo(this.router.url);
    }
  }

  goResume() {
    this.router.navigate(['/resume']);
  }

  goConcepts() {
    this.router.navigate(['/concept/edit']);
  }

  goEmployees() {
    this.router.navigate(['/employees']);
  }

  goIngresos() {
    this.router.navigate(['/invoice/preinvoice']);
  }

  goExpenses() {
    this.router.navigate(['/expense/list']);
  }

  goInvestment() {
    this.router.navigate(['/investment']);
  }

  goOCR() {
    this.router.navigate(['/ocr']);
  }

  goSuscription() {
    this.router.navigate(['/subscription']);
  }

  moveToContent(event: Event, menu: HTMLElement) {
    event.preventDefault();

    if (this.size == SCREEN_SIZE.XS) {
      menu.scrollIntoView({ behavior: 'smooth' });
    }
  }
  public trackByIndex(i: number) { return i; }

}